





































































import { Component, Vue } from 'vue-property-decorator';
import ModalCourseManagement from '@/components/ModalCourseManagement.vue';
import { DbCourseManagement } from "../../database/DbCourseManagement";
import { DbUtile, ResultDbCourseManagement } from '../../database/DbUtile';
import { AuthUtile } from "../../auth/AuthUtile";


@Component({
  components: {
    ModalCourseManagement
  }
})
export default class CourseManagement extends Vue {
  private authUtile = new AuthUtile();
  private dbUtile = new DbUtile();
  rows: ResultDbCourseManagement[] = [];

  searchCourseId = "";
  searchCourseName = "";

  created() {
    console.log('created');
    this.authUtile.checkAuthorizedAdmin()
      .then(() => {
        this.searchCourseId = sessionStorage.getItem("courseManagementsSearchCourseId") ?? "";
        this.searchCourseName = sessionStorage.getItem("courseManagementsSearchCourseName") ?? "";
        this.getCourseManagements(this.searchCourseId, this.searchCourseName);
      })
      .catch((e) => {
        console.error('checkAuthorizedAdmin:', e);
        alert(e);
        this.$router.push('/admin/login/');
      });
  }

  changeCourseManagement() {
    sessionStorage.setItem("courseManagementsSearchCourseId", this.searchCourseId);
    sessionStorage.setItem("courseManagementsSearchCourseName", this.searchCourseName);
    this.getCourseManagements(this.searchCourseId, this.searchCourseName);
  }

  // 講習一覧を取得
  getCourseManagements(courseId: string, courseName: string) {
    this.dbUtile.getCourseManagements(courseId, courseName)
      .then((rows) => {
        console.log("rows", rows);
        // 講習IDでソート
        const sortRows = this.sortCourseManagementRows(rows);
        this.$set(this, "rows", sortRows);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  showModal(id: string | null, src: DbCourseManagement|null) {
    const modal: any = this.$refs.modalCourseManagement;
    modal.showModal(() => {
      // 閉じた時一覧を更新
      this.getCourseManagements(this.searchCourseId, this.searchCourseName);
    }, id, src);
  }

  // 削除 確認
  clickDelete(id: string, src: DbCourseManagement){
    // TODO モーダルで 確認 ダイアログ
    if ( window.confirm(`講習ID：${src.courseId}\n講習名：${src.name} \n削除しますがよろしいですか？`) == false) return;
    this.dbUtile.deleteCourseManagement(id)
      .then((rows) => {
        // 一覧を更新 講習IDでソート
        const sortRows = this.sortCourseManagementRows(rows);
        this.$set(this, "rows", sortRows);
      })
      .catch((e) => {
        console.error("getUsers", e);
      });
  }

  // 詳細 表示
  showDetails(id: string, src: DbCourseManagement){
    console.log("showDetails");
    if (id == 'new') {
      sessionStorage.setItem("courseManagementsSearchCourseId", "");
      sessionStorage.setItem("courseManagementsSearchCourseName", "");
    }
    this.$router.push({ name: 'CourseManagementDetails', params: { id: id } });
  }

  showRegistration(id: string, src: DbCourseManagement){
    console.log("showRegistration");
    this.$router.push({ name: 'Registration', params: { id: id } });
  }

  // 受講画面を 管理者として 開く
  showAttendanceDetails(id: string, src: DbCourseManagement) {
    this.$router.push({ name: 'AdminAttendanceDetails', params: { id: id, admin: 'true' } });
  }

  showHistoryManagement(id: string, src: DbCourseManagement) {
    console.log("showHistoryManagement");
    this.$router.push({ name: 'HistoryManagement', params: { id: id } });
  }

  // 講習IDで降順ソートする
  sortCourseManagementRows(rows: ResultDbCourseManagement[]): ResultDbCourseManagement[] {
   return rows.sort((a, b) =>{
        if(a.data!.courseId > b.data!.courseId) {
          return -1;
        }
        else if(a.data!.courseId < b.data!.courseId) {
          return 1;
        }
        return 0;
   });
  }
}
